'use client';

export const Error = ({ className, ...props }: React.ComponentPropsWithoutRef<'svg'>) => {
	return (
		<svg
			width="32"
			height="32"
			viewBox="0 0 32 32"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			className={className}
			{...props}
		>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M16 20.5C15.6 20.5 15.3 20.6 15 20.9C14.7 21.2 14.6 21.5 14.6 21.9C14.6 22.3 14.7 22.6 15 22.9C15.3 23.2 15.6 23.3 16 23.3C16.4 23.3 16.7 23.2 17 22.9C17.3 22.6 17.4 22.3 17.4 21.9C17.4 21.5 17.3 21.2 17 20.9C16.7 20.6 16.4 20.5 16 20.5ZM16 18C16.3 18 16.5 17.9 16.7 17.7C16.9 17.5 17 17.3 17 17V9C17 8.7 16.9 8.5 16.7 8.3C16.5 8.1 16.3 8 16 8C15.7 8 15.5 8.1 15.3 8.3C15.1 8.5 15 8.7 15 9V17C15 17.3 15.1 17.5 15.3 17.7C15.5 17.9 15.7 18 16 18ZM28.9 10.5C28.2 8.8 27.2 7.3 25.9 6.1C24.6 4.8 23.2 3.8 21.5 3.1C19.8 2.4 17.9 2 16 2C14.1 2 12.2 2.4 10.5 3.1C8.8 3.8 7.3 4.8 6.1 6.1C4.8 7.4 3.8 8.8 3.1 10.5C2.4 12.2 2 14.1 2 16C2 17.9 2.4 19.8 3.1 21.5C3.8 23.2 4.8 24.7 6.1 25.9C7.4 27.2 8.9 28.2 10.5 28.9C12.2 29.6 14 30 16 30C17.9 30 19.7 29.6 21.5 28.9C23.2 28.2 24.7 27.2 25.9 25.9C27.2 24.6 28.2 23.2 28.9 21.5C29.6 19.8 30 18 30 16C30 14.1 29.6 12.2 28.9 10.5ZM24.6 24.6C22.2 27 19.4 28.1 16 28.1C12.6 28.1 9.7 26.9 7.4 24.6C5 22.2 3.9 19.4 3.9 16C3.9 12.6 5.1 9.7 7.4 7.4C9.7 5.1 12.6 3.9 16 3.9C19.4 3.9 22.3 5.1 24.6 7.4C27 9.8 28.1 12.6 28.1 16C28.1 19.4 27 22.2 24.6 24.6Z"
				fill="currentColor"
			/>
		</svg>
	);
};
